import React from "react";
import Visionn from "./Visionn";
import { Helmet } from 'react-helmet';
import TestimonialSection from "./TestimonialAbout";

const About = () => {




  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Mauli Cabs",
    "url": "https://www.maulicabs.com",
    "logo": "https://www.maulicabs.com/logo.png",  // Replace with your actual logo URL
    "description": "Mauli Cabs is a trusted taxi service provider offering reliable cab services across Mumbai and Pune. With a fleet of well-maintained vehicles including Innova Crysta, Ertiga, and sedans, we ensure comfortable one-way and round trips for our customers.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "5465"
    }
  };
  

  

  return (
    <>

<Helmet>
    <title>About Us | Mauli Cabs | Trusted Mumbai to Pune Taxi Service</title>
    <meta
      name="description"
      content="Learn more about Mauli Cabs – a reliable and professional taxi service provider from Mumbai to Pune. Discover our commitment to customer satisfaction and quality travel."
    />
    <meta
      name="keywords"
      content="about mauli cabs, mauli cabs company info, taxi service in mumbai, mumbai to pune cab company, mauli cab drivers, pune mumbai car service, mumbai airport cab provider, safe travel mumbai pune, mauli cabs story, trusted cab service in mumbai"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>


      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">About Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vs-about position-relative space">
        <img
          src="/img/icons/plain-globe.png"
          alt="plain-globe"
          className="about-icon-1 animate-parachute"
        />
        <img
          src="/img/icons/map.png"
          alt="map"
          className="about-icon-2 animate-parachute"
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-auto mx-auto">
              <div className="title-area text-center">
                <span
                  className="sec-subtitle text-capitalize fade-anim"
                  data-direction="top"
                >
                  About Mauli Cabs
                </span>
                <h2 className="sec-title fade-anim" data-direction="bottom">
                  Discover Reliable and Comfortable Travel with Mauli Cabs
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-4 align-items-center">
            <div className="col-md-6 order-1 order-md-0">
              <div className="about-info-area">
                <div className="title-area">
                  <span className="sec-subtitle text-capitalize">
                    Explore Our Services
                  </span>
                </div>
                <div className="about-info">
                  <p>
                    Since its establishment, **Mauli Cabs** has been committed to providing outstanding, dependable, and comfortable travel experiences for all its customers. With a fleet of meticulously maintained vehicles, ranging from economical compact cars to spacious sedans and luxurious SUVs, and a team of skilled, courteous drivers, we ensure that every trip you take is safe, smooth, and enjoyable.
                    <br /><br />
                    Whether you're in need of a quick city ride, daily taxi services, long-distance travel, corporate transportation, or an airport transfer, **Mauli Cabs** offers personalized solutions tailored to meet your specific travel needs. We take pride in delivering timely, affordable, and high-quality transportation services, with an unwavering focus on customer satisfaction.
                  </p>

                  <div className="services-lists">
                    <ul className="custom-ul">
                      {[
                        "Economical and luxurious travel options",
                        "Safe and timely rides to your destination",
                        "Flexible booking and payment options"
                      ].map((text, idx) => (
                        <li key={idx}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                            <path
                              d="M7.99949 15.7247C7.94644 15.7247 7.89396 15.7137 7.84536 15.6924C7.79675 15.6712 7.75308 15.6401 7.71707 15.6011L0.102184 7.36399C0.0514209 7.30907 0.0177684 7.24055 0.00534479 7.16681C-0.0070788 7.09306 0.00226539 7.0173 0.0322339 6.94878C0.0622023 6.88026 0.111495 6.82197 0.174079 6.78104C0.236663 6.7401 0.309824 6.7183 0.384607 6.71829H4.04999C4.10502 6.7183 4.15942 6.73011 4.2095 6.75293C4.25958 6.77575 4.30418 6.80904 4.3403 6.85056L6.88522 9.77841C7.16026 9.19049 7.69268 8.21156 8.62699 7.01872C10.0082 5.25526 12.5774 2.66176 16.9729 0.320525C17.0579 0.275283 17.1567 0.263542 17.2499 0.287618C17.3431 0.311694 17.4239 0.369838 17.4763 0.450569C17.5287 0.531301 17.5489 0.62875 17.533 0.723675C17.5171 0.8186 17.4661 0.904101 17.3902 0.963294C17.3735 0.97641 15.6787 2.31103 13.7282 4.7556C11.9331 7.00522 9.54691 10.6837 8.37272 15.4325C8.3521 15.516 8.30412 15.5901 8.23645 15.6431C8.16878 15.696 8.08532 15.7248 7.99938 15.7248L7.99949 15.7247Z"
                              fill="currentColor"
                            />
                          </svg>
                          {text}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* <div className="btn-trigger btn-bounce">
                    <a href="trips.html" className="vs-btn style6 text-capitalize">
                      View All Services
                    </a>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-md-6 order-0 order-md-1">
              <div className="about-thumb fade-anim" data-direction="right">
                <img
                  src="/images/about.avif"
                  alt="about-thumb"
                  className="w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Visionn/>
      <TestimonialSection/>
    </>
  );
};

export default About;
